<template>
  <div class="around">
    <div style="height:12rem">
      <swiper :options="swiperOption" class="swiper-box">
        <swiper-slide class="swiper-item" v-for="(img, index) in annexInfo" :key="index">
          <img :src="img" />
        </swiper-slide>
        <div class="swiper-pagination swiper-pagination-btn" slot="pagination"></div>
      </swiper>
    </div>
    <!--楼盘信息-->
    <div class="Property">
      <div class="base-info">
        <span>均价：
          <label class="price">{{ avgPrice + '元/平米' }}</label>
        </span>
        <span>{{ buildingType }}</span>
      </div>
      <div>
        <span class="address">{{ address }}</span>
        <div class="nav" @click="mapNav">
          <img src="../assets/image/nav.png" />
        </div>
      </div>
    </div>
  
    <!--周边配套-->
    <div class="facility around">
      <div class="facility-info">
        <div v-html="introduce"></div>
      </div>
    </div>
    <!--悬浮在底部的按钮-->
    <!--<div class="btn-suspension"><img class="icon"src="../assets/image/icon-phone.png" ><span>电话联系</span></div>-->
  </div>
</template>

<script>
import api from '@/script/util'
import { swiper, swiperSlide, swiperPlugins } from 'vue-awesome-swiper'
import '@/style/frozen.css'
import '@/style/base.css'
var u = navigator.userAgent
if (u.indexOf('Android') === -1) {
  var WVJBIframe = document.createElement('iframe')
  WVJBIframe.style.display = 'none'
  WVJBIframe.src = 'wvjbscheme://__BRIDGE_LOADED__'
  document.documentElement.appendChild(WVJBIframe)
}
export default {
  name: '', // 周边楼盘
  components: {
    swiper,
    swiperSlide,
    swiperPlugins
  },
  data () {
    return {
      buildingName: '',
      annexInfo: [],
      address: '',
      avgPrice: '',
      buildingType: '',
      roomLists: [],
      introduce: '',
      latitude: '',
      longitude: '',
      swiperOption: {
        // 如果你后续需要找到当前实例化后的swiper对象以对其进行一些操作的话，可以自定义配置一个名字
        name: 'currentSwiper',
        // 所有配置均为可选（同Swiper配置）
        autoplay: 3000,
        direction: 'horizontal',
        pagination: '.swiper-pagination',
        paginationType: 'fraction',
        paginationClickable: true,
        mousewheelControl: true,
        observeParents: true
        // more Swiper config ...
        // ...
      }
    }
  },
  created: function () {
    let params = {
      id: api.getVal('id')
    }
    api.GetPremisesDetailsInfo(params)
      .then(res => {
        this.annexInfo = res.annex
        this.address = res.address
        this.avgPrice = res.avgPrice
        this.buildingType = res.buildingType
        this.introduce = res.introduce
        this.latitude = res.latitude
        this.longitude = res.longitude
        this.buildingName = res.buildingName
        document.title = this.buildingName
      })
  },
  methods: {
    onSlideChangeStart (currentPage) {
      console.log('onSlideChangeStart', currentPage)
    },
    onSlideChangeEnd (currentPage) {
      console.log('onSlideChangeEnd', currentPage)
    },
    mapNav: function () {
      // eslint-disable
      if (u.indexOf('Android') > -1) {
        UamaJSBridge._app_mapNav(this.longitude, this.latitude)
      } else {
        if (window.WebViewJavascriptBridge) {
          window.WebViewJavascriptBridge.callHandler('_app_mapNav', { 'longitude': this.longitude, 'latitude': this.latitude })
        }
      }
    }
  }
}
</script>


<style  scoped>
.Property {
  padding: 1rem .75rem;
  background-color: #fff;
}

.Property div {
  display: flex;
  justify-content: space-between;
}

.Property .nav {
  width: 3.15rem;
  flex-shrink: 0;
  /*background: url('../assets/image/nav.png') no-repeat;
  background-size: 2.9rem 1.25rem;*/
  height: 1.25rem;
}

.nav img {
  width: 3rem;
  height: 1.25rem;
}

.base-info {
  padding-bottom: 1.1rem;
}

.price {
  color: #ffc001;
  font-weight: 700
}

.around .Property .address {
  padding-right: .75rem;
}


/******详情*****/

@media screen and (min-width: 376px) {
  .room-item {
    font-size: .7rem;
  }
}


/********设施***********/

.facility {
  margin-top: 0.25rem;
  background-color: #fff;
}

.facility-title {
  height: 1.75rem;
  border-bottom: 1px solid #ebebeb;
  padding: 0 .75rem;
  line-height: 1.75rem;
  vertical-align: middle;
}

.facility-title span {
  border-left: 3px solid #ffc001;
  padding-left: .25rem;
}

.facility-info {
  padding: .75rem;
  word-break: break-all;
}

.around {
  padding-bottom: 1.25rem;
}
</style>



// WEBPACK FOOTER //
// around.vue?ced5a4f0